import createIcon from '../../createIcon';

/**
 * @component @name TurnSlightRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuODQgNEgxNi41VjkuNjZIMTQuNVY3LjQxTDkuNSAxMi40MVYyMEg3LjVWMTIuNDJDNy41IDExLjg5IDcuNzEgMTEuMzggOC4wOSAxMS4wMUwxMy4wOSA2LjAxSDEwLjg0VjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurnSlightRight = createIcon('TurnSlightRight', [
  [
    'path',
    {
      d: 'M10.84 4H16.5V9.66H14.5V7.41L9.5 12.41V20H7.5V12.42C7.5 11.89 7.71 11.38 8.09 11.01L13.09 6.01H10.84V4Z',
      key: '1v3z8s',
    },
  ],
]);

export default TurnSlightRight;
